export interface IBlogState {
    fetchBlogsLoading: boolean
    item: IBlog
    fetchBlogLoading: boolean
    items: IBlogsResponse
    actionLoading: boolean
}

export interface IBlogsResponse {
    total_pages: number
    count: number
    data: IBlog[]
}

export interface IBlog {
    id: string
    slug: string
    created_at: string
    modified_at?: string | null
    title_en: string
    title_mk: string
    title_al: string
    content_en: string
    content_mk: string
    content_al: string
    thumbnail: string
    times_read: number
    minutes_read: number

    [key: string]: any
}

export const initialBlogState: IBlog = {
    id: '',
    slug: '',
    title_en: '',
    title_mk: '',
    title_al: '',
    content_en: '',
    content_mk: '',
    content_al: '',
    thumbnail: '',
    minutes_read: 0,
    times_read: 0,
    created_at: '',
    modified_at: null
}

export const initialBlogsState: IBlogsResponse = {
    total_pages: 0,
    count: 0,
    data: []
}
